import styled from 'styled-components';
import { Typ35 } from 'dc/Typ';
import LineHeaderComponent from 'challenge/common/LineHeader';

export const LineHeader = styled(LineHeaderComponent)`
  margin: 24px 0 16px;
`;

export const Header = styled(Typ35)``;
